import { h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import ReactMarkdown from 'react-markdown';

const Panel = ({ ...props }) => {
	return (
		<div styleName='panel' 
      className={ClassNames(props.order)}>
      
      <div className='inner'>
        {props.paragraphs ? props.paragraphs.map((text,i) => {
          return <ReactMarkdown source={text} />
        }) : <i styleName='loading-steam' />}
      </div>
    </div>
	)
};

// export default Panel;
export default CSSModules(Panel, styles);


// WEBPACK FOOTER //
// ./app/frontend/components/panels/panel.stateless.jsx